var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.903,
    height: 36.054,
    viewBox: "0 0 30.903 36.054",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_211855_locked_icon",
    "data-name": "211855_locked_icon",
    d: "M65.8,68.054H93.1a1.8,1.8,0,0,0,1.8-1.779V49.222a1.783,1.783,0,0,0-1.8-1.771H91.362V44.965a14.194,14.194,0,0,0-3.428-9.287A11.7,11.7,0,0,0,79.46,32h-.016a11.727,11.727,0,0,0-8.474,3.67,14.194,14.194,0,0,0-3.428,9.287v2.495H65.8A1.788,1.788,0,0,0,64,49.222V66.275A1.79,1.79,0,0,0,65.8,68.054Zm6-23.089A10.077,10.077,0,0,1,74.068,38.5h0v-.024A7.466,7.466,0,0,1,79.444,36.1h.016a7.466,7.466,0,0,1,5.376,2.374v.016l-.008.008a10.032,10.032,0,0,1,2.261,6.462v2.487H71.806Z",
    transform: "translate(-64 -32)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.99bb20298a668f65a9a7d0cd8f8a9d4e.svg";
export { ForwardRef as ReactComponent };